import { render, staticRenderFns } from "./Python.vue?vue&type=template&id=1bb01bcb&"
import script from "./Python.vue?vue&type=script&lang=js&"
export * from "./Python.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports